export default __webpack_public_path__ + "static/culture@2x-a31afc28609288a38e3468dbf4c2cff8.png";